export default __webpack_public_path__ + "static/media/2.689fd260.svg";